export { default } from './UploadDeviceFile';
